import { FC, MouseEventHandler, useState } from "react";
import { TFunction } from "i18next";

import Button from "components/BaseComponents/Button";
import EmployeeRemoveModal from "./EmployeeRemoveModal";
import { StyledEmpPanelActionButton } from "../EmployeePanel/EmployeePanel.styles";
import { DIGIPOSTHEME } from "theme/digiPosTheme";
import Image, { ICONS } from "components/BaseComponents/Image";
import { useMediaQuery } from "context/media/MediaContext";

interface AgentRemoveProps {
  t: TFunction;
  phoneNumber: string;
  name: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  isDetail: boolean;
}

const AgentRemove: FC<AgentRemoveProps> = ({
  t,
  phoneNumber,
  name,
  onClick,
  isDetail,
}) => {
  const { isMobile } = useMediaQuery();

  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState<boolean>(false);
  onClick = (event): void => {
    event.stopPropagation();
    setIsRemoveModalOpen((prevState) => !prevState);
  };

  return isDetail ? (
    <>
      <Button
        width={isMobile ? "100%" : "130px"}
        text={t("agent_remove").toString()}
        type='button'
        onClick={(event: any) => onClick(event)}
      />

      {isRemoveModalOpen && (
        <EmployeeRemoveModal
          acceptButtonText={t("yes").toString()}
          message={`${name} ${t("agent_remove_message").toString()}`}
          rejectButtonText={t("no").toString()}
          setIsOpen={setIsRemoveModalOpen}
          title={t("information").toString()}
          phoneNumber={phoneNumber!}
        />
      )}
    </>
  ) : (
    <>
      <StyledEmpPanelActionButton
        bgColor={DIGIPOSTHEME.colors.transparent}
        onClick={(event: any) => onClick(event)}
      >
        <Image
          borderRadius='5px'
          backgroundColor={DIGIPOSTHEME.colors.transparent}
          alt='Menu Icon'
          height='35px'
          srcSet={ICONS.DELETE}
          width='35px'
          margin='0 5px'
          tooltipInfo={t("agent_remove").toString()}
        />
      </StyledEmpPanelActionButton>
      {isRemoveModalOpen && (
        <EmployeeRemoveModal
          acceptButtonText={t("yes").toString()}
          message={`${name} ${t("agent_remove_message").toString()}`}
          rejectButtonText={t("no").toString()}
          setIsOpen={setIsRemoveModalOpen}
          title={t("information").toString()}
          phoneNumber={phoneNumber!}
        />
      )}
    </>
  );
};

export default AgentRemove;
